import { Tooltip as ANTDTooltip, TooltipProps as ANTDTooltipProps } from 'antd';
import { useTheme } from 'styled-components';

import { TextProps } from '../../ui/Text/Text';

export interface TooltipProps {
  text: TextProps['children'];
  children: React.ReactNode;
  className?: string;
  visible?: boolean;
  position?: ANTDTooltipProps['placement'];
  showArrow?: boolean;
  open?: ANTDTooltipProps['open'];
}

export function Tooltip({
  text,
  children,
  position,
  showArrow = true,
  visible,
  open,
}: TooltipProps) {
  const theme = useTheme();

  return (
    <ANTDTooltip
      title={visible ? text : undefined}
      placement={position}
      arrow={showArrow}
      color={theme.Components.Tooltip.Color.Background}
      styles={{
        body: {
          fontFamily: theme.Typography.FontFamily,
          textAlign: 'center',
          color: theme.Components.Tooltip.Color.Text,
        },
      }}
      open={open}
    >
      {children}
    </ANTDTooltip>
  );
}
